import styled from "styled-components";

export const MainContainer = styled.div`
display: flex;
flex-direction: column;
gap: 10px;
  .title {
    font-size: 19px;
    font-weight: 500;
    line-height: 19.92px;
  }
  .indications {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .indications p {
    font-size: 12px;
    font-weight: 400;
    line-height: 20.06px;
    text-align: left;
    color: var(--gray-contentoh);
  }
  .drag-area {
    border: 2px dashed var(--pink-contentoh);
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    width: 100%;
    min-height: 150px;
    place-content: center;
    cursor: pointer;
    background-color: var(--white-contentoh);
    transition: background-color 0.3s ease;

    &:hover {
      background-color: var(--light-gray-contentoh);
    }

    .drag-text {
      font-size: 12px;
      color: var(--gray-contentoh);
    }
  }
  .error {
    color: var(--red-contentoh);
    font-size: 0.875rem;
    margin-top: 8px;
  }
`;